import React from 'react';
import { ListItemSelectSizes } from '@wix/design-system';

export interface ListItem {
  className?: string;
  checkbox?: boolean;
  prefix?: React.ReactNode;
  title?: string;
  subtitle?: string;
  suffix?: React.ReactNode;
  selected?: boolean;
  disabled?: boolean;
  size?: ListItemSelectSizes;
  ellipsis?: boolean;
  dataHook?: string;
  sectionId?: string;
  label?: string;
}
